import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ManagementOfChangeService } from 'app/modules/management-of-change/services/management-of-change.service';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { MocApprovalStatus, MocStatus } from 'app/modules/management-of-change/model';
import module from 'app/modules/management-of-change/moc.module';

@Component({
  selector: 'app-application-tracking',
  templateUrl: './moc-application-tracking.page.html',
  imports: module,
  standalone: true,
  styleUrls: ['./moc-application-tracking.page.scss']
})
export class MocApplicationTrackingPage {
  private appTrackingId = this.route.snapshot.paramMap.get('id');
  private action = this.route.snapshot.paramMap.get('action');

  public mocForm: FormGroup
  public mocStatus = MocStatus
  public mocApprovalStatus = MocApprovalStatus

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    public location: Location,
    private mocService: ManagementOfChangeService,
  ) { }

  get isViewOnly() {
    return this.action == 'view' ? true : false;
  }

  get wellName(){
    return this.mocForm.get('wellLongName')?.value;
  }

  get status(){
    return this.mocForm.get('status')?.value;
  }

  get submissionStatus(){
    return this.mocForm.get('submissionStatus')?.value;
  }

  ngOnInit() {
    this.mocForm = this.initializeForm()

    this.mocService.getMocAppTrackingById(this.appTrackingId).subscribe((res) => {
      this.mocForm.patchValue({
        id: this.appTrackingId,
        wellStringId: res.data.wellStringId,
        wellStringShortName: res.data.stringShortName,
        wellStringLongName: res.data.stringLongName,
        fieldLongName: res.data.fieldLongName,
        fieldShortName: res.data.fieldLongName,
        wellShortName: res.data.wellShortName,
        wellLongName: res.data.wellLongName,
        platformLongName: res.data.platformLongName,
        platformShortName: res.data.platformShortName,
        stringIndicatorShortName: res.data.stringIndicatorShortName,
        wellProductionStatus: res.data.wellProductionStatus,
        wellProdStatusInputDate: res.data.wellProdStatusInputDate,
        failureDate: handleFormatDate(res.data.failureDate,false),
        failureEquipment: res.data.failureEquipment,
        problemReported: res.data.problemReported,
        submissionStatus: res.data.submissionStatus,
        submissionDate: handleFormatDate(res.data.submissionDate,false),
        overdueDate: handleFormatDate(res.data.overdueDate,false),
        overdueDays: res.data.overdueDays,
        inputBy: res.data.inputBy,
        inputDate: handleFormatDate(res.data.inputDate, false),
        updateDate: handleFormatDate(res.data.updateDate, false),
      })
      
      // this.initialFormValues = { ...this.cmForm.getRawValue() }
    })
  }

  initializeForm() {
    return this.fb.group({
      id: this.appTrackingId,
      wellStringId: '',
      wellStringShortName: [{ value: '', disabled: true }],
      wellStringLongName: [{ value: '', disabled: true }],
      fieldLongName: [{ value: '', disabled: true }],
      fieldShortName: [{ value: '', disabled: true }],
      platformLongName: [{ value: '', disabled: true }],
      platformShortName: [{ value: '', disabled: true }],
      wellLongName: [{ value: '', disabled: true }],
      wellShortName: [{ value: '', disabled: true }],
      stringIndicatorShortName: [{value: '', disabled: true}],
      wellProductionStatus: [{value: '', disabled: true}],
      wellProdStatusInputDate: [{ value: '', disabled: this.isViewOnly }],
      failureDate: [{ value: '', disabled: this.isViewOnly }],
      failureEquipment: [{ value: '', disabled: this.isViewOnly }],
      problemReported: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      overdueDate: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      overdueDays: [{ value: '', disabled: true }],
      submissionStatus: [{ value: '', disabled: true }],
      submissionDate: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      inputBy: [{ value: '', disabled: true }],
      inputDate: [{ value: '', disabled: true }],
      updateDate: [{ value: '', disabled: true }],
    })
  }

}


